import { render, staticRenderFns } from "./Newsfeed.vue?vue&type=template&id=5a356d73&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Newsfeed.vue"
export default component.exports